import React from "react";
import { Col } from 'react-grid-system';
class Letter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nr: this.props.nr,
            pressed: false,
            letter: this.props.parent.state.cg.letters[this.props.nr],
            style: {
                color: "white",
                background: this.props.centerletter ? "Blue" : "DodgerBlue",
                padding: "1em",
                border: "1px solid black",
                fontFamily: "Arial",
                textAlign: "center",
                borderRadius: "10px"
            }
        };
    }

    clearState() {
        this.setState({
            pressed: false,
            style: {
                ...this.state.style,
                background: this.props.centerletter ? "Blue" : "DodgerBlue",
            }
        })
    }


    render() {
        const shoot = () => {
            if (!this.state.pressed) {
                this.props.parent.addLetter(this.state.letter, this.props.centerletter, this.state.nr);
                let background = this.props.centerletter ? "#126B12" : "Green";
                this.setState({
                    pressed: true,
                    style: {
                        ...this.state.style,
                        background: background,
                    }
                });
            } else {
                this.props.parent.deleteLetter(this.state.nr);
            }
        };

        return (
            <Col xs={this.props.xs} style={this.state.style} onClick={shoot} >
                {this.state.letter}
            </Col>
        );
    }
}

export default Letter;